import React from 'react'

export default function How() {
  return (
    <div className='text-center bg-dark d-block w-100 text-white p-3'>
        <h2>How</h2>
        <p>This Site was created using free Chart generator API: Image-Charts</p>
        <h4 className='text-muted'>Made with ❤ </h4>
        <h4 className='text-muted'>And also ReactJS </h4>
    </div>
  )
}
